var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecordUpper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 108,
    viewBox: "0 0 104 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9046 83.8916V105.082C54.9046 106.69 53.601 108 52 108C50.399 108 49.0954 106.69 49.0954 105.082V83.8916C40.2066 83.1797 32.1927 79.2334 26.226 73.2393C19.6032 66.5947 15.5 57.4277 15.5 47.3467C15.5 45.7383 16.8036 44.4287 18.4046 44.4287C20.0056 44.4287 21.3092 45.7383 21.3092 47.3467C21.3092 55.8193 24.765 63.5273 30.3292 69.1172C35.8935 74.707 43.5662 78.1787 52 78.1787C60.4338 78.1787 68.1065 74.707 73.6708 69.1172C79.235 63.5273 82.6908 55.8193 82.6908 47.3467C82.6908 45.7383 83.9944 44.4287 85.5954 44.4287C87.1964 44.4287 88.5 45.7383 88.5 47.3467C88.5 57.4365 84.3968 66.6035 77.7827 73.248C71.8073 79.2422 63.7934 83.1797 54.9046 83.8916ZM52.1925 0C57.7742 0 62.8485 2.29395 66.523 5.98535C70.1975 9.67676 72.4809 14.7744 72.4809 20.3818V46.749C72.4809 52.3564 70.1975 57.4541 66.523 61.1455C62.8485 64.8369 57.7742 67.1309 52.1925 67.1309C46.6107 67.1309 41.5364 64.8369 37.8619 61.1455C34.1874 57.4541 31.904 52.3564 31.904 46.749V20.3818C31.904 14.7744 34.1874 9.67676 37.8619 5.98535C41.5364 2.29395 46.6107 0 52.1925 0ZM62.4111 10.1162C59.7864 7.47949 56.1644 5.84473 52.1925 5.84473C48.2118 5.84473 44.5985 7.47949 41.9739 10.1162C39.3492 12.7529 37.722 16.3916 37.722 20.3818V46.749C37.722 50.748 39.3492 54.3779 41.9739 57.0147C44.5985 59.6514 48.2205 61.2861 52.1925 61.2861C56.1732 61.2861 59.7864 59.6514 62.4111 57.0147C65.0357 54.3779 66.663 50.7393 66.663 46.749V20.3818C66.6717 16.3828 65.0357 12.7529 62.4111 10.1162Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86 10L86 34",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 34L17.5 10",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.5 16L100.5 29",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 28L3 15",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 108,
    fill: "white",
    transform: "translate(15.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordUpper);
export default __webpack_public_path__ + "static/media/record-upper.cbd0fca0e05e51891f08cb8dbc80495e.svg";
export { ForwardRef as ReactComponent };